import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Safe rich-markdown renderer for Mirror answers.
 *
 * Raw HTML is disabled and remote images render as inert alt text, so model
 * prose cannot inject DOM or cause the browser to fetch a tracking pixel.
 * Legacy answers keep Home's established renderer during the dark rollout.
 *
 * `singleTilde: false` (M4D WS1, Lane 1121): advisor prose is full of lone
 * approximation tildes (~2.6%, ~$2.9M), and remark-gfm's default pairs two
 * separated lone tildes into a deletion span — Ryan's Kalrez letter rendered
 * a whole passage struck through. Only deliberate ~~double-tilde~~ syntax
 * may strike text; a lone ~ stays literal.
 */
export default function ChatMarkdown({ content, isDraft = false }) {
  return (
    <div className={`hm-chat-markdown${isDraft ? ' is-draft' : ''}`}>
      <ReactMarkdown
        remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
        skipHtml
        components={{
          a: ({ node, children, ...props }) => {
            void node;
            return (
              <a {...props} target="_blank" rel="noreferrer noopener">
                {children}
              </a>
            );
          },
          table: ({ node, children, ...props }) => {
            void node;
            return (
              <div className="hm-chat-markdown-table-wrap">
                <table {...props}>{children}</table>
              </div>
            );
          },
          img: ({ alt }) => (
            <span className="hm-chat-markdown-image-alt">
              {alt || 'Image'}
            </span>
          ),
        }}
      >
        {content || ''}
      </ReactMarkdown>
    </div>
  );
}
